<template>
  <div class="cc-legend">
    <div class="cc-legend__group">
      <span class="cc-legend__label">{{ translate('Status') }}:</span>
      <span class="cc-legend__chip" :style="{ background: '#67C23A' }">{{ translate('Completed') }}</span>
      <span class="cc-legend__chip" :style="{ background: '#E6A23C' }">{{ translate('InProgress') }}</span>
      <span class="cc-legend__chip" :style="{ background: '#409EFF' }">{{ translate('Paused') }}</span>
      <span class="cc-legend__chip" :style="{ background: '#F56C6C' }">{{ translate('Overdue') }}</span>
      <span class="cc-legend__chip cc-legend__chip--muted" :style="{ background: '#DCDFE6' }">{{ translate('Pending') }}</span>
    </div>
    <div class="cc-legend__group">
      <span class="cc-legend__label">{{ translate('Category') }}:</span>
      <span class="cc-legend__cat"><span class="cc-legend__bar" style="background: #409EFF"></span>{{ translate('MaterialProvisioning') }}</span>
      <span class="cc-legend__cat"><span class="cc-legend__bar" style="background: #E6A23C"></span>{{ translate('External') }} (Ext)</span>
      <span class="cc-legend__cat"><span class="cc-legend__bar" style="background: #909399"></span>{{ translate('Other') }} (Oth)</span>
      <span class="cc-legend__cat cc-legend__cat--dashed">{{ translate('NonBlocking') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorkflowLegendBar',
}
</script>

<style lang="scss" scoped>
.cc-legend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px 24px;
  font-size: 11px;
  color: #303133;
  padding: 6px 0;

  &__group {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
  }
  &__label {
    font-weight: 600;
    color: #606266;
    margin-right: 4px;
  }
  &__chip {
    color: #fff;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 10px;
    font-weight: 500;
    &--muted { color: #303133; }
  }
  &__cat {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 1px 6px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;

    &--dashed { border-style: dashed; color: #909399; }
  }
  &__bar {
    display: inline-block;
    width: 4px;
    height: 12px;
    border-radius: 2px;
  }
}
</style>
